import { render, staticRenderFns } from "./linkFacebook.vue?vue&type=template&id=7f1bcb4e&"
import script from "./linkFacebook.vue?vue&type=script&lang=js&"
export * from "./linkFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports